// extracted by mini-css-extract-plugin
export default {"features":"features_features__PenTr","title":"features_title__cyZuE"};